import Vue from 'vue'
import Vuex from 'vuex'
import API from '@/plugins/api'
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const firebase_app = initializeApp({
  apiKey: "AIzaSyAUAtr5sxZX5MK334vQxCNeKRxpc32NoZQ",
  projectId: "default-events",
});
const firebase_auth = getAuth(firebase_app);

Vue.use(Vuex)
Vue.use(API)

const app = new Vue();

export default new Vuex.Store({
  state: {
    accessToken: null,
    currentUser: null, // null-not loaded yet, false-noone is logged in, object is user
    backendUserData: null,
    // Daten
    events: [],
  },
  mutations: {
    resetPartnerState(state) {
      state.active_partner = null;
      state.partner = [];
      state.kunden = [];
      state.personen = [];
      state.projekte = [];
    }
  },
  actions: {
    async startup(context) {
      firebase_auth.onAuthStateChanged((user) => {
        if (user) {
          context.state.currentUser = user;
          context.state.accessToken = user.accessToken;
          app.$api.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
          context.dispatch('initPartnerOfUser');
        } else {
          context.state.currentUser = false;
          context.state.backendUserData = false;
          context.state.accessToken = null;
          delete app.$api.defaults.headers.common['Authorization'];
          context.commit('resetPartnerState');
        }
      });
    },
    async login(_, { email, password } = {}) {
      return signInWithEmailAndPassword(firebase_auth, email, password);
    },
    async logout(_) {
      return firebase_auth.signOut();
    },
    async initEvent(context, event_id) {
      if (context.state.events.find(event => event.id == event_id)) return;
      let loaded = null;
      while (loaded === null) {
        await context
          .dispatch("updateEvent", event_id)
          .then(() => (loaded = true))
          .catch((err) => {
            if (err.message.includes('NOT_FOUND')) throw err;
            console.error(err);
          });
        await new Promise((resolve) => setTimeout(() => resolve(), 1000));
      }
    },
    async updateEvent(context, event_id) {
      let event = await app.$api.get('/event', { params: { id: event_id } }).then(res => res.data[0])
        .catch((err) => {
          if (err.response.status == 404) throw new Error('NOT_FOUND(event)');
          throw err;
        });
      context.state.events = [
        ...context.state.events.filter(event => event.id != event_id),
        event,
      ];
    },
  },
  getters: {
    currentUser(state) {
      return state.currentUser;
    },
    backendUserData(state) {
      return state.backendUserData;
    },
    events(state) {
      return state.events;
    },
  }
})
